import React from 'react';
import { Text, Link, Image, Heading, Box } from 'pcln-design-system';
import { InlineLocationLink } from './InlineLocationLink';
import { InlineCitationLink } from './InlineCitationLink';
export const SimpleMarkdownElement = props => {
  const {
    element,
    setLineMarginLeft,
    handleMapButtonClick,
    pinsInCurrentLine
  } = props;
  if (typeof element !== 'object') {
    return null;
  }
  if (element.elementType === 'HEADER') {
    return React.createElement(Heading.h4, null, element.content);
  }
  // if the text is under a list item, it should be indented
  const startOfTheListItem = element.containerType === 'LIST_ITEM' && element.newLineStart;
  if (startOfTheListItem) {
    setLineMarginLeft(3);
  }
  if (element.elementType === 'TEXT') {
    const isbold = element.style === 'bold';
    const fontStyle = element.style === 'italic' ? 'italic' : '';
    return React.createElement(Text.span, {
      bold: isbold,
      fontStyle: fontStyle
    }, startOfTheListItem && React.createElement(Text.span, null, " - "), element.content);
  }
  if (element.elementType === 'LINK') {
    const metadata = element.metadata;
    if (metadata && metadata.type === 'CITATION') {
      return React.createElement(React.Fragment, null, startOfTheListItem && React.createElement(Text.span, null, " - "), React.createElement(InlineCitationLink, {
        metadata: metadata
      }));
    }
    if (metadata && metadata.type) {
      return React.createElement(React.Fragment, null, startOfTheListItem && React.createElement(Text.span, null, " - "), React.createElement(InlineLocationLink, {
        metadata: metadata,
        handleMapButtonClick: handleMapButtonClick,
        pinsInCurrentLine: pinsInCurrentLine,
        googlePinMeta: metadata
      }));
    }
    return React.createElement(Link, {
      href: element.URL,
      target: '_blank'
    }, startOfTheListItem && React.createElement(Text.span, null, " - "), element.content);
  }
  if (element.elementType === 'IMAGE') {
    return React.createElement(Image, {
      src: element.URL,
      alt: element.content,
      width: 100,
      height: 'auto'
    });
  }
  if (element.elementType === 'HORIZONTAL_RULE') {
    return React.createElement(Box, {
      mb: 1
    }, "---");
  }
  return null;
};